import './responsive_header.less';

import React, {Proptypes} from 'react';
import {Link} from 'react-router';
import cookies from '../util/cookie';

class ResponsiveDashboardHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSlideNotification : false
    };
    this.toggleState =  this.toggleState.bind(this);
    this.logout = this.logout.bind(this);
  }

  toggleState(){
    var bodyClass = document.querySelector('body').classList;

    if(this.state.showSlideNotification){
      this.setState({
        showSlideNotification : false
      })
        bodyClass.remove('scroll-lock-loggedin');
    }
    else {
      this.setState({
        showSlideNotification : true
      })
      bodyClass.add('scroll-lock-loggedin');
    }
  }

  logout() {
    this.props.logout();
  }

  renderResponsiveHeader(){
    const {props} = this;
    return (
      <div className = "dashboard-responsive-header">
        <div className = "cf responsive-header-wrp wrapper" >
          <div className = "awb-header-logo-wrp f-l">
            <Link to="/dashboard">
              <img className = "awb-dashboard-logo" src="../public/images/landing/logo_white_saffron.png" />
            </Link>
          </div>
          <div className = "f-r awb-btn" onClick={this.toggleState}><span className="icon-three-bars"></span></div>
        </div>
      </div>
    );
  }

  renderSlideNotificationBar(userProfileImage){

    let {isVerified} =  this.props.user;

    return(
      <div className = "dashboard-responsive-header">
        <div className = "slide-notification-bar">
          <div className = "awb-header-logo-wrp cf">
            <Link to="/dashboard" onClick={this.toggleState}>
              <img className = "awb-logo-elm" id="slideBarLogo" src="../public/images/landing/logo_white_saffron.png"/>
            </Link>
            <span className = "f-r icon-cross-feather awb-btn" onClick={this.toggleState}></span>
          </div>
          {/*<div className="navigation-elm"><Link>Learn More</Link></div>*/}
          <div className="navigation-elm" onClick={this.toggleState}><Link activeClassName="nav-selected" to="/dashboard">Dashboard</Link></div>
          { <div className="navigation-elm" onClick={this.toggleState}><Link activeClassName="nav-selected" to="/browse-shipments">Browse</Link></div> }

          <div className="navigation-elm" onClick={this.toggleState}><Link activeClassName="nav-selected" to="/inbox">Messages</Link></div>
          <div className="navigation-elm" onClick={this.toggleState}><Link activeClassName="nav-selected" to="/all-notifications">Notifications</Link></div>

          <div className="navigation-elm" onClick={this.toggleState}><Link activeClassName="nav-selected" to="/profile">Profile</Link></div>
          <div className="navigation-elm" onClick={this.toggleState}><Link activeClassName="nav-selected" to="/account">Account</Link></div>
          <div className="user-profile-pic-wrp">
            <div className="img-wrap">
              <Link to="/profile"><img className="user-profile-pic awb-btn"  src={userProfileImage} /></Link>
              {isVerified && <div className="profile-is-verified"></div>}
            </div>
            <span className="user-profile-name" onClick={this.logout}>Sign Out</span>
          </div>
        </div>
    </div>
    )
  }

  render(){
      const {state} = this;
      var self = this;
      let {props} = this;
      let userProfileImage;
      if(props.user) {
        userProfileImage = props.user.imageUrl || "../../public/images/user_placeholder.svg";
       }
      const renderData = state.showSlideNotification ? this.renderSlideNotificationBar(userProfileImage) : this.renderResponsiveHeader();

      return (
          <div>
            {renderData}
          </div>
      )
  }
}

// ResponsiveDashboardHeader.propTypes = {
//   user: React.Proptype.object
// }

module.exports = ResponsiveDashboardHeader;



// WEBPACK FOOTER //
// app/header_dashboard/responsive_header.jsx